
export const numberDecimal = {
  bind (el, binding) {
    let scale = binding.value || 2
    el.addEventListener('input', (e) => {
      let value = e.target.value;
      let scales = {
        s1: /^(\-)*(\d+)\.(\d).*$/,
        s2: /^(\-)*(\d+)\.(\d\d).*$/,
        s3: /^(\-)*(\d+)\.(\d\d\d).*$/,
        s4: /^(\-)*(\d+)\.(\d\d\d\d).*$/,
        s5: /^(\-)*(\d+)\.(\d\d\d\d\d).*$/,
        s6: /^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/,
      }
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/^\./g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      value = value.replace(scales['s' + scale], '$1$2.$3');

      e.target.value = value;
      return value
    });
  }
}